import {Component, HostListener, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BalancaSerialService} from '../../services/balanca-serial.service';
import {ConfiguracaoBalanca, configuracaoPadraoBalanca, ModeloBalanca, PERFIS_BALANCA} from '../../services/protocolo-balanca';

@Component({
  selector: 'app-configuracao-balanca',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './configuracao-balanca.component.html',
  styleUrls: ['./configuracao-balanca.component.scss']
})
export class ConfiguracaoBalancaComponent implements OnInit {
  emDialog = false;
  window: {close: () => void};
  config: ConfiguracaoBalanca;
  mensagem = '';
  erroConfiguracao = '';

  constructor(public balanca: BalancaSerialService) {
    this.config = balanca.configuracao;
  }

  ngOnInit(): void { void this.balanca.reconectarAutomaticamente(); }

  @HostListener('keydown.escape', ['$event'])
  fecharDialog(event: KeyboardEvent): void {
    if (!this.emDialog) return;
    event.stopPropagation();
    this.window.close();
  }

  get perfil() { return PERFIS_BALANCA[this.config.modelo]; }
  get alterada(): boolean { return JSON.stringify(this.config) !== JSON.stringify(this.balanca.configuracao); }

  mudarModelo(modelo: ModeloBalanca): void {
    this.config = configuracaoPadraoBalanca(modelo);
    this.mensagem = '';
    this.erroConfiguracao = '';
  }

  restaurarPadrao(): void { this.mudarModelo(this.config.modelo); }

  salvar(): boolean {
    this.mensagem = '';
    this.erroConfiguracao = '';
    try {
      this.balanca.salvarConfiguracao(this.config);
      if (!this.balanca.avisoPreferencias) this.mensagem = 'Preferências salvas neste navegador.';
      return true;
    } catch (erro) {
      this.erroConfiguracao = erro.message;
      return false;
    }
  }

  async conectar(escolherPorta = false): Promise<void> {
    this.erroConfiguracao = '';
    if (this.alterada && !this.salvar()) return;
    try { await this.balanca.conectar(escolherPorta); }
    catch (erro) {
      if (erro?.name !== 'NotFoundError') this.erroConfiguracao = this.balanca.erro || erro.message;
    }
  }

  async testar(): Promise<void> {
    this.mensagem = '';
    this.erroConfiguracao = '';
    try { await this.balanca.lerPeso(true); }
    catch (erro) { /* O diagnóstico fica visível no serviço compartilhado com o PDV. */ }
  }
}
